import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAdminEvents } from '../../hooks/useAdminEvents';
import './AdminLayout.css';

const PORTAL = '/ft-portal';

const NAV_GROUPS = [
  {
    label: 'Overview',
    items: [
      { path: `${PORTAL}/dashboard`,    label: 'Dashboard',        icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> },
    ]
  },
  {
    label: 'Instructors',
    items: [
      { path: `${PORTAL}/applications`,  label: 'Instructor Requests',     icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> },
      { path: `${PORTAL}/instructors`,   label: 'Instructors',      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> },
    ]
  },
  {
    label: 'Students',
    items: [
      { path: `${PORTAL}/student-requests`, label: 'Student Requests', icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg> },
      { path: `${PORTAL}/students`,         label: 'Students',         icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg> },
      { path: `${PORTAL}/reviews`,          label: 'Reviews',          icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> },
    ]
  },
  {
    label: 'Finance',
    items: [
      { path: `${PORTAL}/revenue`,   label: 'Revenue',    icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg> },
      { path: `${PORTAL}/referrals`, label: 'Referrals',  icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg> },
      { path: `${PORTAL}/payments`,  label: 'Payments',   icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg> },
      { path: `${PORTAL}/refunds`,   label: 'Refunds',    icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/><path d="M9 7h1m4 0h1"/><line x1="12" y1="3" x2="12" y2="9"/><path d="M10 6l2-2 2 2" strokeWidth="1.8"/></svg> },
    ]
  },
  {
    label: 'System',
    items: [
      { path: `${PORTAL}/cms`,          label: 'CMS Editor',    icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg> },
      { path: `${PORTAL}/test-centres`, label: 'Test Centres',  icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
      { path: `${PORTAL}/contacts`,     label: 'Contacts',      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg> },
      { path: `${PORTAL}/settings`,     label: 'Settings',      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg> },
    ]
  }
];

const EVENT_ICONS = {
  new_application:    '📋',
  new_student_request:'🎓',
  new_student:        '👥',
  new_payment:        '💳',
  new_contact:        '✉️',
};

function AdminLayout({ children, pageTitle = 'Admin Portal' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { admin, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [toasts, setToasts] = useState([]);

  const handleLogout = async () => {
    await logout();
    navigate(`${PORTAL}/login`);
  };

  const dismissToast = (id) => setToasts(t => t.filter(x => x.id !== id));

  const handleEvent = useCallback((evt) => {
    const id = Date.now() + Math.random();
    setToasts(t => [...t.slice(-4), { id, ...evt }]); // max 5 at once
    setTimeout(() => dismissToast(id), 6000);
  }, []);

  useAdminEvents(handleEvent);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div className="al-shell">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="al-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ── */}
      <aside className={`al-sidebar${sidebarOpen ? ' al-sidebar--open' : ''}`}>
        {/* Brand */}
        <div className="al-brand">
          <div className="al-brand-icon">FT</div>
          <div className="al-brand-text">
            <span className="al-brand-name">Fast Track</span>
            <span className="al-brand-sub">Admin Portal</span>
          </div>
        </div>

        {/* Nav */}
        <nav className="al-nav">
          {NAV_GROUPS.map((group) => (
            <div key={group.label} className="al-nav-group">
              <span className="al-nav-group-label">{group.label}</span>
              {group.items.map((item) => (
                <button
                  key={item.path}
                  onClick={() => { navigate(item.path); setSidebarOpen(false); }}
                  className={`al-nav-item${isActive(item.path) ? ' al-nav-item--active' : ''}`}
                >
                  <span className="al-nav-icon">{item.icon}</span>
                  <span className="al-nav-label">{item.label}</span>
                  {isActive(item.path) && <span className="al-nav-indicator" />}
                </button>
              ))}
            </div>
          ))}
        </nav>

        {/* Sidebar footer */}
        <div className="al-sidebar-footer">
          <div className="al-admin-chip">
            <div className="al-admin-avatar">
              {(admin?.email?.[0] || 'A').toUpperCase()}
            </div>
            <div className="al-admin-info">
              <span className="al-admin-email">{admin?.email || 'Admin'}</span>
              <span className="al-admin-role">{admin?.role || 'Administrator'}</span>
            </div>
          </div>
          <button onClick={handleLogout} className="al-logout-btn">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            Logout
          </button>
        </div>
      </aside>

      {/* ── Main Area ── */}
      <div className="al-main">
        {/* Top bar */}
        <header className="al-topbar">
          <button
            className="al-menu-toggle"
            onClick={() => setSidebarOpen(s => !s)}
            aria-label="Toggle navigation"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
          <h1 className="al-page-title">{pageTitle}</h1>
          <div className="al-topbar-right">
            <span className="al-portal-badge">Admin</span>
          </div>
        </header>

        {/* Page content */}
        <div className="al-content">
          {children}
        </div>
      </div>

      {/* ── Toast notifications ── */}
      <div className="al-toast-stack" aria-live="polite">
        {toasts.map(t => (
          <div key={t.id} className="al-toast" onClick={() => t.tab && navigate(`${PORTAL}/${t.tab}`)} style={{ cursor: t.tab ? 'pointer' : 'default' }}>
            <span className="al-toast-icon">{EVENT_ICONS[t.type] || '🔔'}</span>
            <span className="al-toast-msg">{t.message}</span>
            <button className="al-toast-close" onClick={e => { e.stopPropagation(); dismissToast(t.id); }} aria-label="Dismiss">×</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminLayout;
